import React, {useContext, useEffect, useRef} from "react";
import styles from "./processMapViews/ProcessMapViews.module.scss";
import ViewItem from "./processMapViews/ViewItem";
import axios from "axios";
import appContext from "../../../../context/appContext";
import http from "../../../../services/api/utilities/http";

const ProcessMapViews = ({ showModal = false, handleTriggerShowModal }) => {
  const [disabledCostProperty, setDisabledCostProperty] = React.useState(false);

  const node = useRef(null);

  const context = useContext(appContext)
  useEffect(() => {
    if (context.handleUid().id) {
      http.get(
          `/process_mining/attribute_search/${context.handleUid().id}`
      ).then(res => {
          setDisabledCostProperty(res.data.data["COST"] === undefined);
          context.handleDisableCostProperty(res.data.data["COST"] === undefined);
        })
        .catch(err=>{
          console.log(err.response);
        })
    }
  },[context.handleUid().id])

  const handleOutsideClick = e => {
    if (!node.current.contains(e.target)) {
      handleTriggerShowModal();
    }
  };

  useEffect(() => {
    if (showModal) {
      document.addEventListener("click", handleOutsideClick, false);
    }
    return function cleanupListener() {
      document.removeEventListener('click', handleOutsideClick, false)
    }
  }, [showModal]);

  return (
    <div
      className={[styles.ModalBox, (showModal ? styles.show : styles.hide)].join(' ')}
      ref={node}
    >
      <div>
        <span className={styles.title}>
          <span>Views</span>
        </span>
        <span className={styles.close} onClick={handleTriggerShowModal}>
          <i>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="15.8333" y1="5.22732" x2="5.22724" y2="15.8333" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M4.94446 4.94442L15.7862 15.7861" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </i>
        </span>
      </div>
      <div>
        <ViewItem disabledCostProperty={disabledCostProperty} handleTriggerShowModal={handleTriggerShowModal}/>
      </div>
    </div>
  )
};

export default ProcessMapViews;